module.exports = __webpack_public_path__ + "img/Planetario.22cadb28.png";